import { AiAssistantMainMenuTileItemSummaryFormBean } from './AiAssistantMainMenuTileItemSummaryForm.types';
import { AiAssistantMainMenuTileItemSummaryModalResult } from './AiAssistantMainMenuTileItemSummaryModal.types';
import { plainTextToEditorValue } from './AiAssistantMainMenuTileItemSummaryModal.utils';

export const formInitializer = (
   result: AiAssistantMainMenuTileItemSummaryModalResult
) => (): AiAssistantMainMenuTileItemSummaryFormBean => {
   const examination = plainTextToEditorValue(result?.examination ?? '');
   const interview = plainTextToEditorValue(result?.interview ?? '');
   const recommendations = plainTextToEditorValue(result?.recommendations ?? '');

   return {
      examination: examination,
      interview: interview,
      recommendations: recommendations,
      transferInterview: interview !== null,
      transferExamination: examination !== null,
      transferRecommendations: recommendations !== null,
   };
};
